import { defineStore } from "pinia";
import type { AddPassenger } from "~/istypes";
import { useUserStore} from "~/stores/user";

export const usePassengersStore = defineStore('passengers', () => {
    const config = useRuntimeConfig();
    const userStore = useUserStore();

    const getPassengers = async () => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/passengers`,{
                    method: "POST",
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });
                
                return res;

            }catch(error){
                return error;
            }
        }
    }

    const deletePassengers = async (id: number | string) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/passengers/destroy`,{
                    method: "POST",
                    body: { passenger_id: id},
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });
                
                return res;

            }catch(error){
                return error;
            }
        }
    }

    const addPassengers = async (data: AddPassenger) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/passengers/store`,{
                    method: "POST",
                    body: data,
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });
                
                return res;

            }catch(error){
                return error;
            }
        }
    }

    const editPassengers = async (data: AddPassenger) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/passengers/store`,{
                    method: "POST",
                    body: data,
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });
                
                return res;

            }catch(error){
                return error;
            }
        }
    }

    const getCountry = async () => {
        try {
            const res = await $fetch<any>(`${config.public.ApiRest}countries`, {
                method: "GET",
            });

            return res;
        } catch (error) {
            console.error("Error fetching:", error);
        }
        
    }


    return { getPassengers,deletePassengers,addPassengers,editPassengers,getCountry };
});